export default "__VITE_ASSET__D4yQHAH5__"